module.exports = __webpack_public_path__ + "static/media/tier-10.53527780.jpg";